var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("side-panel", {
    on: { close: _vm.close },
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function() {
            return [
              _c("h3", { staticClass: "mt-0 clearfix" }, [
                _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
              ])
            ]
          },
          proxy: true
        },
        {
          key: "content",
          fn: function() {
            return [
              _c("preloader", { attrs: { display: _vm.loading } }),
              _vm._v(" "),
              !_vm.loading
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "prelative" },
                      [
                        _c("preloader", {
                          staticClass: "mt-5",
                          attrs: { display: _vm.processing }
                        }),
                        _vm._v(" "),
                        _vm.activeMode === "read"
                          ? _c(
                              "link-button",
                              {
                                staticClass: "fright",
                                attrs: {
                                  permissions: _vm.permissions,
                                  permToCheck: "can_edit_opportunity"
                                },
                                on: { clicked: _vm.activeEditMode }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$l10n.__("Editer")) +
                                    "\n                "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h3", { staticClass: "mt-1 mb-3" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Informations")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.processing,
                                expression: "!processing"
                              }
                            ],
                            ref: "opportunityForm",
                            attrs: {
                              labelPosition: "top",
                              model: _vm.opportunity,
                              rules: _vm.rules,
                              inlineMessage: true,
                              labelWidth: "120px"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__(
                                    "forms.OpportunityForm.opportunity_name"
                                  ),
                                  prop: "name",
                                  error: _vm.errors.get("name")
                                }
                              },
                              [
                                _c("text-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    placeholder: _vm.$t.__(
                                      "forms.OpportunityForm.opportunity_placeholder"
                                    ),
                                    "data-bot": "opportunity-name-input"
                                  },
                                  model: {
                                    value: _vm.opportunity.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "name", $$v)
                                    },
                                    expression: "opportunity.name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.status"),
                                  prop: "status",
                                  error: _vm.errors.get("signed")
                                }
                              },
                              [
                                _c("select-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    options: _vm.signedOptions,
                                    idColumn: "id",
                                    "data-bot": "opportunity-status-input"
                                  },
                                  model: {
                                    value: _vm.opportunity.signed,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "signed", $$v)
                                    },
                                    expression: "opportunity.signed"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__(
                                    "common.labels.potential_amount"
                                  ),
                                  prop: "potentialAmount",
                                  error: _vm.errors.get("potentialAmount")
                                }
                              },
                              [
                                _c("amount-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    placeholder: _vm.$t.__(
                                      "common.labels.potential_amount"
                                    ),
                                    "data-bot":
                                      "opportunity-potential-amount-input"
                                  },
                                  model: {
                                    value: _vm.opportunity.potentialAmount,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.opportunity,
                                        "potentialAmount",
                                        $$v
                                      )
                                    },
                                    expression: "opportunity.potentialAmount"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__(
                                    "forms.OpportunityForm.due_date"
                                  ),
                                  prop: "dueDate",
                                  error: _vm.errors.get("dueDate")
                                }
                              },
                              [
                                _c("date-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    placeholder: _vm.$t.__(
                                      "common.labels.date"
                                    ),
                                    format: _vm.formatDate,
                                    "data-bot": "opportunity-date-input"
                                  },
                                  model: {
                                    value: _vm.opportunity.dueDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "dueDate", $$v)
                                    },
                                    expression: "opportunity.dueDate"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.pipeline"),
                                  prop: "funnelId",
                                  error: _vm.errors.get("funnelId")
                                }
                              },
                              [
                                _c("select-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    options: _vm.funnelOptions,
                                    labelColumn: "name",
                                    idColumn: "id",
                                    "data-bot": "opportunity-funnel-id-select"
                                  },
                                  model: {
                                    value: _vm.opportunity.funnelId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "funnelId", $$v)
                                    },
                                    expression: "opportunity.funnelId"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.step"),
                                  prop: "stepId",
                                  error: _vm.errors.get("stepId")
                                }
                              },
                              [
                                _c("select-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    options: _vm.stepOptions,
                                    labelColumn: "label",
                                    idColumn: "id",
                                    "data-bot": "opportunity-step-select"
                                  },
                                  on: { input: _vm.stepUpdated },
                                  model: {
                                    value: _vm.opportunity.stepId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "stepId", $$v)
                                    },
                                    expression: "opportunity.stepId"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.probability"),
                                  prop: "proba",
                                  error: _vm.errors.get("proba")
                                }
                              },
                              [
                                _c("percent-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    placeholder: _vm.$t.__(
                                      "common.labels.probability"
                                    ),
                                    "data-bot": "opportunity-probability-input"
                                  },
                                  model: {
                                    value: _vm.opportunity.proba,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "proba", $$v)
                                    },
                                    expression: "opportunity.proba"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.note"),
                                  prop: "brief",
                                  error: _vm.errors.get("brief")
                                }
                              },
                              [
                                _c("rich-text-input", {
                                  attrs: {
                                    value: _vm.opportunity.brief,
                                    mode: _vm.activeMode,
                                    "data-bot": "opportunity-note-textarea"
                                  },
                                  on: {
                                    "update:value": function(value) {
                                      return (_vm.opportunity.brief = value)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("h3", { staticClass: "mt-5 mb-3" }, [
                              _vm._v(
                                _vm._s(_vm.$l10n.__("Informations Sellsy"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__(
                                    "forms.OpportunityForm.assigned_staff"
                                  ),
                                  prop: "staffs",
                                  error: _vm.errors.get("staffs")
                                }
                              },
                              [
                                _c("autocomplete-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    placeholder: _vm.$t.__(
                                      "forms.OpportunityForm.assigned_staff"
                                    ),
                                    options: _vm.staffOptions,
                                    labelColumn: "fullName",
                                    idColumn: "id",
                                    "data-bot": "opportunity-staffs-input",
                                    relatedData: _vm.relatedData
                                  },
                                  model: {
                                    value: _vm.opportunity.staffs,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "staffs", $$v)
                                    },
                                    expression: "opportunity.staffs"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__("forms.OpportunityForm.id"),
                                  prop: "ident",
                                  error: _vm.errors.get("ident")
                                }
                              },
                              [
                                _c("text-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    placeholder: _vm.$t.__(
                                      "forms.OpportunityForm.id"
                                    ),
                                    "data-bot": "opportunity-id-input"
                                  },
                                  model: {
                                    value: _vm.opportunity.ident,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "ident", $$v)
                                    },
                                    expression: "opportunity.ident"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.source"),
                                  prop: "sourceId",
                                  error: _vm.errors.get("sourceId")
                                }
                              },
                              [
                                _c("select-input", {
                                  attrs: {
                                    mode: _vm.activeMode,
                                    options: _vm.sourceOptions,
                                    placeholder: _vm.$t.__(
                                      "common.labels.source"
                                    ),
                                    labelColumn: "name",
                                    idColumn: "id",
                                    "data-bot": "opportunity-source-id-select"
                                  },
                                  model: {
                                    value: _vm.opportunity.sourceId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "sourceId", $$v)
                                    },
                                    expression: "opportunity.sourceId"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__(
                                    "forms.OpportunityForm.linked_company"
                                  ),
                                  prop: "linkedid",
                                  error: _vm.errors.get("linkedid")
                                }
                              },
                              [
                                _c("autocomplete-remote-input", {
                                  staticClass: "tags-150",
                                  attrs: {
                                    relatedData: _vm.relatedData,
                                    mode: _vm.activeMode,
                                    placeholder: _vm.$t.__(
                                      "forms.OpportunityForm.linked_company"
                                    ),
                                    preset: _vm.opportunity.thirds,
                                    limit: 1,
                                    route: "/rest/thirds/autocomplete",
                                    "data-bot": "opportunity-corp-related-input"
                                  },
                                  on: {
                                    emptied: _vm.emptyContact,
                                    change: _vm.fetchContactForThird
                                  },
                                  model: {
                                    value: _vm.activelinkedid,
                                    callback: function($$v) {
                                      _vm.activelinkedid = $$v
                                    },
                                    expression: "activelinkedid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__(
                                    "forms.OpportunityForm.linked_contact"
                                  ),
                                  prop: "contacts",
                                  error: _vm.errors.get("contacts")
                                }
                              },
                              [
                                _c("autocomplete-input", {
                                  staticClass: "tags-150",
                                  attrs: {
                                    mode: _vm.activeMode,
                                    placeholder: _vm.$t.__(
                                      "forms.OpportunityForm.linked_contact"
                                    ),
                                    options: _vm.contactOptions,
                                    labelColumn: "fullName",
                                    idColumn: "id",
                                    relatedData: _vm.relatedData,
                                    "data-bot":
                                      "opportunity-contact-related-input"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function() {
                                          return _vm._l(
                                            _vm.contactOptions,
                                            function(item) {
                                              return _c(
                                                "el-option",
                                                {
                                                  key: item["id"],
                                                  attrs: {
                                                    label: item["fullName"],
                                                    value: parseInt(item["id"])
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex-level"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "option-fullname mr-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.fullName
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "grey flex-item-right regular ellipsis"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.position
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3957527646
                                  ),
                                  model: {
                                    value: _vm.opportunity.contacts,
                                    callback: function($$v) {
                                      _vm.$set(_vm.opportunity, "contacts", $$v)
                                    },
                                    expression: "opportunity.contacts"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.customFields.length > 0
                              ? _c(
                                  "section",
                                  [
                                    _c("h3", { staticClass: "mt-5 mb-3" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$l10n.__("Champs personnalisés")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("customfields", {
                                      attrs: {
                                        cfs: _vm.customFields,
                                        cfv: _vm.customFieldValues,
                                        emitEditSuccess: _vm.emitEditSuccess,
                                        mode: _vm.activeMode,
                                        context: _vm.contextCFS,
                                        errors: _vm.errors
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.popupNewIdent
                ? _c("CompassDialog", {
                    staticClass: "opportunity-form__dialog",
                    attrs: {
                      visible: _vm.popupNewIdent,
                      size: "large",
                      title: _vm.$t.__(
                        "forms.OpportunityForm.opportunity_number_already_exist"
                      )
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.popupNewIdent = $event
                      },
                      closed: _vm.closePopupNewIdent
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("div", { staticClass: "dialog__default" }, [
                                _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Vous avez saisi un numéro d'opportunité existant. Souhaitez vous le modifier ?"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ])
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "footer",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "dialog__footer" },
                                [
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__("common.actions.edit"),
                                      type: "primary"
                                    },
                                    on: { click: _vm.closePopupNewIdent }
                                  }),
                                  _vm._v(" "),
                                  _c("CompassButton", {
                                    staticClass: "ml-2",
                                    attrs: {
                                      label: _vm.$t.__(
                                        "forms.OpportunityForm.save_opportunity"
                                      ),
                                      type: "primary"
                                    },
                                    on: { click: _vm.saveWithoutNewIdent }
                                  }),
                                  _vm._v(" "),
                                  _c("CompassButton", {
                                    staticClass: "ml-2",
                                    attrs: {
                                      label: _vm.$t.__(
                                        "forms.OpportunityForm.follow_numbering_and_continue"
                                      ),
                                      type: "primary"
                                    },
                                    on: { click: _vm.saveWithNewIdent }
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1853200280
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("CompassDialog", {
                attrs: {
                  visible: _vm.displayConfirmAutomation,
                  size: "small",
                  primaryAction: {
                    label: _vm.$t.__("forms.OpportunityForm.send_email"),
                    action: _vm.confirmAutomation
                  },
                  secondaryActions: [
                    {
                      label: _vm.$t.__(
                        "forms.OpportunityForm.do_not_send_email"
                      ),
                      action: _vm.cancelAutomation
                    }
                  ],
                  title: _vm.$t.__(
                    "forms.OpportunityForm.automatic_email_sending"
                  ),
                  closeOnClickOverlay: false
                },
                on: {
                  "update:visible": function($event) {
                    _vm.displayConfirmAutomation = $event
                  },
                  closed: _vm.persistSave
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function() {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "typographies-paragraph-medium-regular"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Une action d’envoi automatique d'email est activée sur cette étape. Confirmez-vous l'envoi de cet email ?"
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ]
          },
          proxy: true
        },
        !_vm.loading
          ? {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "flex-level" },
                    [
                      _vm.permissions.can_delete_opportunity &&
                      _vm.mode !== "add" &&
                      _vm.action !== "duplicate"
                        ? _c("CompassIconButton", {
                            staticClass: "flex-item-left flex-level",
                            attrs: { icon: "bin", variant: "destructive" },
                            on: {
                              click: function($event) {
                                _vm.goToUrl(
                                  _vm.buildUrl(
                                    _vm.deleteAction.value,
                                    _vm.parameters
                                  )
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-right" },
                        [
                          _vm.activeMode === "edit"
                            ? _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__("common.actions.cancel"),
                                  type: "secondary"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.close($event)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeMode === "edit"
                            ? _c("CompassButton", {
                                staticClass: "ml-1",
                                attrs: {
                                  label: _vm.$t.__("common.actions.save"),
                                  type: "primary",
                                  disabled: _vm.processing || _vm.loading
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.submitForm("opportunityForm")
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          : null
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }